import { create } from 'zustand';

import { ApplicationFlagsStoreType } from './types';

export const useApplicationFlags = create<ApplicationFlagsStoreType>((set, _get) => ({
  minimum_app_version: '',
  show_coming_soon_apps: false,
  elevate_ai_enabled: false,
  marketplace_v2_flag: false,
  manager_v2_app_release: true,
  enable_terminal_presence_wake_check: true,
  setAllFlags: ({
    minimum_app_version,
    show_coming_soon_apps,
    elevate_ai_enabled,
    marketplace_v2_flag,
    manager_v2_app_release,
    enable_terminal_presence_wake_check,
  }) => {
    set({
      minimum_app_version,
      show_coming_soon_apps,
      elevate_ai_enabled,
      marketplace_v2_flag,
      manager_v2_app_release,
      enable_terminal_presence_wake_check,
    });
  },
}));
